import apiClient from '@/utils/apiClient';

const ENDPOINT = '/api/price-list-supplier-comparisons/';

/**
 * @param {string} priceListType
 * @param {number|string|null} priceListId
 * @returns {{ type: string, price_list_id: (number|string) }}
 */
function scopeParams(priceListType, priceListId) {
    return {
        type: priceListType || 'general',
        price_list_id: priceListId || 'none',
    };
}

/**
 * @param {string} priceListType
 * @param {number|string|null} priceListId
 * @param {string} [productCode] - when set, only sims that include this product code
 * @returns {Promise<Array<Object>>}
 */
export async function fetchSupplierComparisons(priceListType, priceListId, productCode = '') {
    const params = scopeParams(priceListType, priceListId);
    const code = String(productCode || '').trim();
    if (code) {
        params.product_code = code;
    }
    const response = await apiClient.get(ENDPOINT, {
        params,
    });
    return Array.isArray(response.data) ? response.data : [];
}

/**
 * @param {object} params
 * @param {string} params.priceListType
 * @param {number|string|null} params.priceListId
 * @param {string} params.name
 * @param {string[]} params.productCodes
 * @param {Record<string, unknown>} params.simulationState
 * @param {string} [params.referenceProductCode]
 * @param {string} [params.notes]
 * @returns {Promise<Object>}
 */
export async function createSupplierComparison({
    priceListType,
    priceListId,
    name,
    productCodes,
    simulationState,
    referenceProductCode = '',
    notes = '',
}) {
    const response = await apiClient.post(ENDPOINT, {
        ...scopeParams(priceListType, priceListId),
        name,
        notes,
        productCodes,
        simulationState,
        referenceProductCode,
    });
    return response.data;
}

/**
 * @param {number|string} id
 * @param {object} patch
 * @returns {Promise<Object>}
 */
export async function updateSupplierComparison(id, patch) {
    const response = await apiClient.patch(`${ENDPOINT}${id}/`, patch);
    return response.data;
}

/**
 * @param {number|string} id
 * @returns {Promise<void>}
 */
export async function deleteSupplierComparison(id) {
    await apiClient.delete(`${ENDPOINT}${id}/`);
}
